import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, MessageCircleIcon } from 'lucide-react';
export function FinalExpensesSection() {
  const whatsappLink = 'https://wa.me/17863975041?text=Hola%20Ricmary%2C%20quiero%20informaci%C3%B3n%20sobre%20gastos%20finales%20para%20mis%20padres.%20Vivo%20en%20%5BTU%20ESTADO%5D.%20%C2%BFMe%20puedes%20enviar%20el%20ebook%20gratis%20y%20orientarme%3F';
  return <section className="py-20 px-6 bg-white" data-id="element-59">
      <div className="max-w-4xl mx-auto" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-gold/20 to-gold/5 rounded-3xl p-8 md:p-12 border border-gold/30 text-center relative overflow-hidden" data-id="element-61">
          {/* Decorative background icon */}
          <HeartIcon className="absolute -right-10 -bottom-10 w-64 h-64 text-gold/10 rotate-12 pointer-events-none" data-id="element-62" />

          <div className="relative z-10" data-id="element-63">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-64">
              <HeartIcon className="w-8 h-8 text-gold-dark fill-gold/20" data-id="element-65" />
            </div>

            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-navy font-bold mb-6" data-id="element-66">
              ¿Necesitas información para proteger a tus padres (gastos
              finales)?
            </h2>

            <p className="text-lg text-gray-800 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-67">
              Si estás pensando en cubrir gastos finales y evitar que la familia
              cargue con ese golpe económico, escríbeme y te explico opciones
              según tu estado.
            </p>

            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-navy hover:bg-navy-light text-white px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-68">
              <MessageCircleIcon className="w-6 h-6" data-id="element-69" />
              Preguntar por gastos finales
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}